var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('RedeemCode'):_c('RedeemSignUp')}
var staticRenderFns = []

export { render, staticRenderFns }